var FooterModule = /** @class */ (function () {
    function FooterModule() {
    }
    return FooterModule;
}());
export { FooterModule };
